<template>
   <div class="row">
    <div class="col-sm-12">
       <h3>Class Dashboard</h3>
       <hr>
       <CRow>
        <CCol class="col-sm-4">
          <label>Filter Class</label>
          <select class="form-control" v-model="meta.ikid_class_name" @change="loadClassFilter">
              <option value="0">Show All</option>
              <option v-for="item in listclass" :key="item.id" :value="item.name">{{ item.name }}</option>
          </select>
        </CCol>
        <CCol class="col-sm-4">
          <label >Filter Status</label>
         <select
           class="form-control "
           v-model="meta.checkin_status"
           @change="loadStatus"
         >
           <option value="5">Show All</option>
           <option value="1">Check In</option>
           <option value="2">In Class</option>
           <option value="3">Queued</option>
           <option value="4">Check Out</option>
         </select>
        </CCol>
        <CCol class="col-sm-4 search">
          <label >Search</label>
         <input type="text" class="form-control  " @input="search" />
        </CCol>
       </CRow>
       <div class="clearfix"><br /></div>
     </div>
     </div>

 </template>

 <script>
 import _ from "lodash";
 import moment from "moment";
 import service from "@/services/service";
 import axios from "axios";
 import store from "@/store.js";

 export default {
   name: "Table",
   props: {
     items: Array,
     caption: {
       type: String,
       default: "Table",
     },
     hover: Boolean,
     striped: Boolean,
     bordered: Boolean,
     small: Boolean,
     fixed: Boolean,
     dark: Boolean,
     items: {
       type: Array,
       required: true,

     },
     listclass:{
         type: Array,
         required: true,
      },
     fields: {
       type: Array,
       required: true,
     },
     meta: {
       required: true,
     },
     btn_show: {
       required: true,
     },
     btn_edit: {
       required: true,
     },
    //  btn_deactivate: {
    //    required: true,
    //  },
     btn_reactivate: {
       required: true,
     },
    //  btn_destroy: {
    //    required: true,
    //  },
     is_uuid: {
       required: true,
     },
    //  is_search_by_date: {
    //    required: true,
    //  },
   },
   data() {
     return {
       sortBy: null,
       sortDesc: false,
       deleteModal: false,
       selected: null,
       selectID: null,
       inc: 5,
     };
   },
   watch: {
     sortBy(val) {
       this.$emit("sort", {
         sortBy: this.sortBy,
         sortDesc: this.sortDesc,
       });
     },
     sortDesc(val) {
       this.$emit("sort", {
         sortBy: this.sortBy,
         sortDesc: this.sortDesc,
       });
     },
   },
   methods: {
     getPhoto(data) {
       if (data) {
         return axios.defaults.baseURL + "/getfile/memberphoto/" + data;
       } else {
         return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
       }
     },
     openURL(data) {
      this.$router.push({ name: "Kids Check"});
      let routeData = this.$router.resolve({path: '/ikids/detail',query: {id:data} })
      window.open(routeData.href, '_blank');

     },

     loadPerPage(val) {
       this.$emit("per_page", this.meta.per_page);
     },

     loadIsActive(val) {
       this.$emit("is_active", this.meta.is_active);
     },

     loadStatus(val) {
       this.$emit("status_filter", this.meta.checkin_status);
     },

     loadClassFilter(val) {
       this.$emit("class_filter", this.meta.ikid_class_name)
       const path = window.location.href.split('?')[0]
       let url = path
       if(this.meta.ikid_class_name !== '0'){
        url = path + '?class='+ this.meta.ikid_class_name
       }
       url = url.toLowerCase()
       history.replaceState({}, null, url);
      },

     changePage(val) {
       this.$emit("pagination", val);
     },

     search: _.debounce(function(e) {
       this.$emit("search", e.target.value);
     }, 500),

     // ----------------------------
     checkin: function(id) {
       this.$emit("checkin",id);
     },

     present: function(id) {
       this.$emit("present",id);
     },

     checkout: function(id) {
       this.$emit("checkout", id);
     },

     forceCheckout: function(id) {
       this.$emit("forceCheckout", id);
     },

     cancelStatus: function(id, stat) {
       this.$emit("cancelStatus", id, stat);
     },

     forceCancelStatus: function(id, stat) {
       this.$emit("forceCancelStatus", id, stat);
     },

     // ----------------------------

     inclass: function(id) {
       this.$emit("inclass", id);
     },

     queue: function(id) {
       this.$emit("queue", id);
     },

     checkout: function(id) {
       this.$emit("checkout", id);
     },

     reactivate: function(id) {
       this.$emit("reactivate", id);
     },

     destroy: function(id) {
       this.$emit("destroy", id);
     },

     resetpassword: function(id) {
       this.$emit("resetpassword", id);
     },

     grantwebaccess: function(id) {
       this.$emit("grantwebaccess", id);
     },

     converttomember: function(id) {
       this.$emit("converttomember", id);
     },

     frontEndDateFormat: function(date) {
       return moment(date, "YYYY-MM-DD").format("DD MMMM YYYY");
     },
   },
 };
 </script>

<style scoped>

@media (max-width: 600px) {

  .search {
  position: absolute;
  top: 10rem;
  }

}

</style>
